import { render } from "./GenerationOfCourseScriptsView.vue?vue&type=template&id=2d3f9838"
import script from "./GenerationOfCourseScriptsView.vue?vue&type=script&lang=js"
export * from "./GenerationOfCourseScriptsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__